import {
  Box,
  HStack,
  Icon,
  SkeletonCircle,
  SkeletonText,
  Text,
  VStack,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
  RiBookmarkLine,
  RiCalendarTodoFill,
  RiTimerLine,
  RiTvLine,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import VimeoEmbed from "../../../components/VimeoEmbed";
import axiosInstance from "../../../helpers/api";
import Player from "../../vdoPlayer/player";
import {
  allowedClicks,
  getHomeworkExamMessage,
  getViewsCount,
  getViewsExceededMessage,
  isClickControlled,
  isClickPlaybackBlocked,
  isDurationExceeded,
  isHomeworkExamSuspended,
} from "./func";

const VideoPreview = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const [otp, setOtp] = useState("");
  const [playBack, setPlayBack] = useState("");
  const videoDetails = useSelector((state) => state.chapterVideos.videoDetails);
  const seenLoading = useSelector((state) => state.chapterVideos.seenLoading);

  const getVideoData = async (id) => {
    //console.log(id, "get");
    const res = await axiosInstance.get(`/student/videos/otp/${id}`);
    setOtp(res?.data?.otp);
    setPlayBack(res?.data?.playbackInfo);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    if (id) {
      getVideoData(id);
    }
  }, [id]);
  return (
    <VStack
      bg="main_1"
      borderRadius="8px"
      p="20px"
      color="white"
      w="100%"
      h="100%"
      alignItems="flex-start"
      spacing="15px"
      position="relative"
    >
      {/* title */}
      <Text fontSize="28px" fontWeight="500">
        {videoDetails?.title}
      </Text>

      {/* videoDetails */}
      <Box bg="gray" w="100%" h="100%" alignSelf="center" borderRadius="8px">
        {isDurationExceeded(videoDetails) ||
        isClickPlaybackBlocked(videoDetails) ? (
          <Text textAlign="center" p={4} fontSize="20px">
            {getViewsExceededMessage()}
          </Text>
        ) : isHomeworkExamSuspended(videoDetails) ? (
          <Text textAlign="center" p={4} fontSize="20px">
            {getHomeworkExamMessage(videoDetails)}
          </Text>
        ) : videoDetails?.video_type == 2 ? (
          <VimeoEmbed videoUrl={videoDetails?.url} data={videoDetails} />
        ) : loading ? null : (
          <Player otp={otp} playbackInfo={playBack} data={videoDetails} />
        )}
      </Box>

      {/* options */}
      {seenLoading ? (
        <HStack w="100%" bg="transparent">
          <SkeletonCircle size="6" startColor="gray.100" endColor="gray.600" />
          <SkeletonText
            startColor="gray.100"
            endColor="gray.600"
            w="80%"
            mt="4"
            noOfLines={1}
            spacing="4"
          />
        </HStack>
      ) : (
        <HStack
          justifyContent="space-between"
          w="100%"
          fontSize={{ base: "10px", lg: "18px" }}
        >
          <HStack spacing={{ base: "5px", lg: "50px" }}>
            <HStack spacing="8px" w="100%">
              <Icon as={RiCalendarTodoFill} />
              <Text w="fit-content">
                {dayjs(videoDetails?.created_at).format("D , MMM ,YYYY")}
              </Text>
            </HStack>
            {/* {diff && (
              <HStack spacing="8px" w="100%">
                <Icon as={RiTimerLine} />
                <Text w="fit-content">{diff} Days remaining</Text>
              </HStack>
            )} */}
            {isClickControlled(videoDetails) && (
              <HStack spacing="8px" w="100%">
                <Icon as={RiTvLine} />
                <Text w="fit-content">{`Watch ${Math.max(
                  allowedClicks(videoDetails) - getViewsCount(videoDetails),
                  0
                )} more times (${Math.min(
                  getViewsCount(videoDetails),
                  allowedClicks(videoDetails)
                )}/${allowedClicks(videoDetails)})`}</Text>
              </HStack>
            )}
          </HStack>

          <Icon as={RiBookmarkLine} display={{ base: "none", lg: "block" }} />
        </HStack>
      )}
    </VStack>
  );
};

export default VideoPreview;
